import { createContext } from 'react';

export default createContext({
  lists: [],
  move: () => {},
});
